import approvalRaw from "./approval.json";
import { multiply, withId } from "./utils";

export const approval = withId(multiply(approvalRaw, 8));

export { default as activities } from "./activities";
export { default as users } from "./users";
export { default as projects } from "./projects";
export { default as statuses } from "./statuses";
export { default as budgetTypes } from "./budgetTypes";
export { default as currencies } from "./currencies";
export { default as resourceStatuses } from "./resourceStatuses";
export { default as expenseStatuses } from "./expenseStatuses";
export { default as expenses } from "./expenses";
